if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.minicart = document.querySelector("mini-cart");
        this.quickViewDrawer = this.closest("quick-view-drawer");
        this.eventContext = this.form.dataset.eventContext;
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(event) {
        event.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) {
          return;
        }

        this.handleErrorMessage();

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".button-overlay-spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.minicart.getSectionsToRender().map((section) => section.section),
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);
              this.minicart.updateSectionContents();
              return;
            }

            this.minicart.renderContents(response);

            if (window.themeSettings.redirectToCart) {
              location.href = window.routes.cart_url;
            } else {
              if (this.quickViewDrawer) {
                this.quickViewDrawer.close();
                // Immediately re-add the 'drawer-open' class to avoid
                // the drawer backdrop from flashing.
                document.body.classList.add("drawer-open");
                setTimeout(() => this.minicart.open(), 200);
              } else {
                this.minicart.open(submitButton);
              }
            }

            const event = new CustomEvent("cart:item-add", {
              detail: {
                items: [response],
                context: this.eventContext,
              },
            });
            document.dispatchEvent(event);

            publish(PUB_SUB_EVENTS.cartItemAdd, {
              source: this.eventContext,
              items: [response],
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
            this.querySelector(".button-overlay-spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) {
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form-error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form-error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}






// document.addEventListener('DOMContentLoaded', function() {
//   const colorInputs = document.querySelectorAll('.variant-image-swatch input[type="radio"]');
  
//   colorInputs.forEach(input => {
//     input.addEventListener('change', function() {
//       if (this.checked) {
//         const colorName = this.nextElementSibling.getAttribute('data-color-name');
//         const selectedColorSpan = this.closest('.variant-image-swatch').querySelector('.selected-color-name');
        
//         if (selectedColorSpan && colorName) {
//           selectedColorSpan.textContent = colorName;
//         }
//       }
//     });
//   });
// });

// Optimized JavaScript for instant color name updates
(function() {
  'use strict';
  
  // Function to update color name immediately
  function updateColorName(input) {
    const colorName = input.nextElementSibling.getAttribute('data-color-name') || 
                     input.nextElementSibling.getAttribute('data-tooltip') ||
                     input.value;
    
    const fieldset = input.closest('.variant-image-swatch');
    const selectedColorSpan = fieldset?.querySelector('.selected-color-name');
    
    if (selectedColorSpan && colorName) {
      selectedColorSpan.textContent = colorName;
    }
  }
  
  // Function to initialize color update listeners
  function initColorUpdates() {
    const colorInputs = document.querySelectorAll('.variant-image-swatch input[type="radio"]');
    
    colorInputs.forEach(input => {
      // Remove existing listeners to prevent duplicates
      input.removeEventListener('change', handleColorChange);
      input.removeEventListener('click', handleColorClick);
      
      // Add immediate response listeners
      input.addEventListener('change', handleColorChange, { passive: true });
      input.addEventListener('click', handleColorClick, { passive: true });
    });
  }
  
  // Handle color change with immediate update
  function handleColorChange(event) {
    if (event.target.checked) {
      updateColorName(event.target);
    }
  }
  
  // Handle color click for even faster response
  function handleColorClick(event) {
    // Update immediately on click, before change event
    updateColorName(event.target);
  }
  
  // Initialize immediately if DOM is ready, otherwise wait
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColorUpdates, { once: true });
  } else {
    initColorUpdates();
  }
  
  // Re-initialize when Shopify updates variants (for AJAX updates)
  document.addEventListener('shopify:section:load', initColorUpdates, { passive: true });
  
  // Also listen for variant changes (Shopify's built-in events)
  document.addEventListener('variant:change', function(event) {
    // Small delay to ensure Shopify's updates are complete
    requestAnimationFrame(() => {
      initColorUpdates();
    });
  }, { passive: true });
  
  // Fallback for themes that don't use standard events
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && 
          mutation.attributeName === 'checked' && 
          mutation.target.matches('.variant-image-swatch input[type="radio"]')) {
        if (mutation.target.checked) {
          updateColorName(mutation.target);
        }
      }
    });
  });
  
  // Observe changes to radio button states
  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['checked']
  });
  
})();